import './App.css';
import Footer from './Footer';
import Topbar from './Topbar';
import Mission from './Mission';
import { useEffect } from 'react';

function Main() {
    useEffect(() => {

        const canvas = document.getElementById('binaryCanvas');
        const ctx = canvas.getContext('2d');

        // Handle resizing
        function resizeCanvas() {
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;
        }
        resizeCanvas();
        window.addEventListener('resize', resizeCanvas);

        // Grid setup
        const fontSize = 16;
        let columns = Math.floor(canvas.width / fontSize);
        let drops = Array(columns).fill(1);

        // Track mouse position
        const mouse = { x: -1000, y: -1000 };
        window.addEventListener('mousemove', (e) => {
            mouse.x = e.clientX;
            mouse.y = e.clientY;
        });

        // Re-calculate columns smoothly if window size changes
        window.addEventListener('resize', () => {
            columns = Math.floor(canvas.width / fontSize);
            drops = Array(columns).fill(1);
        });

        function draw() {
            // Semi-transparent white background creates the trailing fade effect
            ctx.fillStyle = 'rgba(255, 255, 255, 0.08)';
            ctx.fillRect(0, 0, canvas.width, canvas.height);

            ctx.font = fontSize + 'px monospace';

            for (let i = 0; i < drops.length; i++) {
                // Randomly choose 0 or 1
                const text = Math.random() > 0.5 ? '1' : '0';
                
                // Calculate exact screen position of the character
                const x = i * fontSize;
                const y = drops[i] * fontSize;

                // Calculate distance from this character to the mouse pointer
                const dx = x - mouse.x;
                const dy = y - mouse.y;
                const distance = Math.sqrt(dx * dx + dy * dy);

                // Check if character is within a 150-pixel hover radius
                if (distance < 150) {
                    // Lighter gray highlight near the pointer
                    ctx.fillStyle = '#dddddd';
                } else {
                    // Default medium gray color
                    ctx.fillStyle = '#b8b8b8';
                }

                ctx.fillText(text, x, y);

                // Reset drop to the top with a random delay if it goes off screen
                if (y > canvas.height && Math.random() > 0.975) {
                    drops[i] = 0;
                }

                // Move the drop down the screen
                drops[i]++;
            }
        }

        // Loop animation at roughly 60 frames per second
        setInterval(draw, 75);

      }, []);

  return (
    <div>
        <Topbar />
        <br />
        <br />
        
        {/* <div className="stlmade-logo"> </div> */}
        {/* <div className="pointer"></div>   */}
        <div className="axis x"></div>
        {/* <div className="axis y"></div> */}
        <div className="binary-canvas">
            <canvas id="binaryCanvas"></canvas>
        </div>

        <div className="services-section sticky-section bg-gray-100 z-50 py-50"> 
                {/* grid 2 columns  */}
                <div className="bottom-0 grid lg:grid-cols-2 md:grid-cols-2 gap-x-8 gap-y-1 sm:grid-cols-1">
                    <div className="flex justify-left col-1">
                        <div className="mb-2 mt-1 pl-16 py-2 lg:py-2 sm:mb-1 sm:py-1 lg:pl-14">
                            <h2 className="services-heading text-balance text-2xl font-semibold tracking-tight text-gray-900 sm:text-3xl">
                                Select from our services
                            </h2>
                        </div>
                    </div>
                    <div className="flex justify-left col-2">
                        <div className="mb-2 mt-2 py-1 md:py-2 lg:py-2 sm:py-1 pl-16 lg:pl-14">
                            <a
                                href="/servicerequest"
                                className="rounded-md bg-gray-600 mr-3 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                            >
                                Services
                            </a>
                            <a href="/services" className="text-sm/6 font-semibold text-gray-900 gap-x-6">
                                Learn more <span aria-hidden="true">→</span>
                            </a>
                        </div>
                    </div>                                        
                </div>
            </div>

        <div className="ml-3">
            {/* <BusinessStatistics className="mt-8 py-2 sm:py-5 mr-4 ml-4"/> */}
            <br />
            <div className="z-50">
                <Mission />
            </div>
            <br />
            <br />
        </div>
        <Footer />
    </div>
    );
}

export default Main;